<template>
  <div style="margin-left:60px">
    <el-form :model="formData" :rules="ruleValidate" ref="cFrom" label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="显示名称" prop="showName">
            <el-input v-model="formData.showName" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="参数名" prop="queryField">
            <el-input v-model="formData.queryField" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="类型" prop="type">
            <el-select v-model="formData.type" placeholder="请选择" @change="typeChange">
              <el-option label="输入框" :value="'0'"></el-option>
              <el-option label="单选框" :value="'1'"></el-option>
              <el-option label="多选框" :value="'2'"></el-option>
              <el-option label="日期" :value="'3'"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" style="min-height:1px">
          <el-form-item label-width="0" prop="exchange" v-if="formData.type=='1'||formData.type=='2'" class="tx-c">
            <el-button type="text" @click="setExchange">设定值</el-button>
          </el-form-item>
          <el-form-item label-width="0" prop="queryType" v-if="formData.type=='0'||formData.type=='3'" class="tx-c">
            <el-checkbox v-model="formData.queryType" :true-label="'1'" :false-label="'0'">{{formData.type=='3'?'范围查询':'模糊查询'}}</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="2" class="tx-c" v-if="itemIndex>0">
          <el-button icon="el-icon-minus" @click="removeSearchItem"></el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      title="设定值"
      :visible.sync="show"
      width="400px"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <div>
        <el-row>
          <el-col :span="11">
            <div class="tx-c">选项名</div>
          </el-col>
          <el-col :span="11">
            <div class="tx-c">值</div>
          </el-col>
        </el-row>
        <ExchangeItemForm 
          v-for="(item, index) in formData.exchange" 
          :key="item.key" ref="dictionary" 
          @removeItem="removeItem(index)" 
          :defualtData="formData.exchange[index]"
          :exchangeIndex="index"
        />
        <div class="tx-c mt10"><el-button icon="el-icon-plus" @click="addExchange"></el-button></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="validateDictionaryForm">确 定</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ExchangeItemForm from './exchangeItemForm'

export default {
  name: "searchItemForm",
  components: {
    ExchangeItemForm,
  },
  props: ['itemIndex','myKey','itemData'],
  data() {
    return {
      show: false,
      baseUrl: process.env.BASE_URL,
      formData: {
        exchange: [],
        type: '',
        queryField: '',
        showName: '',
        queryType: '',
        key: '',
      },
      stringifyExchange: '',
      ruleValidate: {
        queryField: [
          {required: true, message: '参数名不能为空', trigger: 'blur'}
        ],
        exchange: [
          {required: true, message: '请设定值', trigger: 'blur'}
        ],
        showName: [
          {required: true, message: '显示名称不能为空', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请选择类型', trigger: 'blur'}
        ],
      },
    }
  },
  computed: {
  },
  created() {
    // this.setKey()
    this.setDefualtData()
  },
  mounted() {},
  destroyed() {},
  methods: {
    setExchange(){
      this.show = true
      if(this.formData.exchange.length==0){
        this.formData.exchange.push({
          name: '',
          value: '',
          key: (new Date()).getTime() // 加入唯一标识避免渲染错误
        })
      }
      const _this = this
      this.$nextTick(() => {
        _this.formData.exchange.forEach((item, index) => {
          _this.$refs.dictionary[index].getDefualtData()
        });
      })
    },
    addExchange(){
      const exchange = this.formData.exchange
      this.formData.exchange.push({
        name: '',
        value: '',
        key: (new Date()).getTime() // 加入唯一标识避免渲染错误
      })
      const _this = this
      this.$nextTick(() => {
        _this.$refs.dictionary[_this.formData.exchange.length - 1].getDefualtData()
      })
    },
    handleClose(){
      // 过滤掉未保存的数据
      this.formData.exchange = this.formData.exchange.filter(item => {
        return (item.name && item.value)
      })
      this.show = false
    },
    validateDictionaryForm(){
      let resultArr = []
      const _this = this;
      function checkForm(index) {
        let result = new Promise(function(resolve, reject) {
          _this.$refs.dictionary[index].$refs.dictionaryForm.validate((valid) => {
            if (valid) {
              resolve(_this.$refs.dictionary[index].getData());
            } else {
              reject()
            }
          })
        })
        resultArr.push(result)
      }
      this.formData.exchange.forEach((item, index) => {
        checkForm(index)
      });
      Promise.all(resultArr).then((res) => {
        this.formData.exchange = res
        this.stringifyExchange = JSON.stringify(res)
        this.show = false
      })
    },
    removeItem(index){
      this.formData.exchange.splice(index, 1)
    },
    getValue(){
      return this.formData
    },
    removeSearchItem(){
      this.$emit('removeItemForm', {dataName: 'queryCondDefList', index: this.itemIndex})
    },
    setDefualtData(){
      this.formData = {
        key: this.itemData.key,
        type: this.itemData.type,
        queryField: this.itemData.queryField,
        showName: this.itemData.showName,
        queryType: this.itemData.queryType,
        exchange: [],
      }
      if(this.itemData.exchange && this.itemData.exchange.length){
        this.formData.exchange = JSON.parse(this.itemData.exchange)
        this.stringifyExchange = this.itemData.exchange
      }
    },
    typeChange(){
      this.formData.queryType = '0';
    },
  },
  watch: {
    formData: {
      handler(val) {
        let data = JSON.parse(JSON.stringify(val))
        data.exchange = this.stringifyExchange
        this.$emit('searchItemFormChange', {data, index: this.itemIndex})
      },
      deep: true,
    }
  },
  filters: {}
};
</script>

<style scoped lang="less">
</style>
